import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { FC, ReactElement, ReactNode } from 'react';

type Props = {
  title: string | ReactNode;
  /**
   * The element wrapped in a Tooltip needs to be able to hold a ref!
   * https://mui.com/material-ui/react-tooltip/
   * https://mui.com/components/tooltips/#limitations
   */
  children: ReactElement;
  className?: TooltipProps['className'];
  arrow?: boolean;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  showOnDisabled?: boolean;
};

export const StyledTooltip = styled(({ className, ...props }: Props) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [` .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    whiteSpace: 'pre-line',
    lineHeight: '1rem',
    padding: '0.5rem 1rem',
    borderRadius: '.5rem'
  },
  [` .${tooltipClasses.arrow}`]: {
    color: theme.palette.primary.main
  }
}));

export const TooltipComponent: FC<Props> = ({ children, showOnDisabled, ...rest }) => {
  if (showOnDisabled) {
    return (
      <StyledTooltip {...rest}>
        <span>{children}</span>
      </StyledTooltip>
    );
  }
  return <StyledTooltip {...rest}>{children}</StyledTooltip>;
};
